import { HttpClient } from '@angular/common/http';
import { cmsApi } from '../constants/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var IndexmanagerService = /** @class */ (function () {
    function IndexmanagerService(http) {
        this.http = http;
        this.checkMonth = [
            {
                number: 1,
                name: 'มกราคม'
            },
            {
                number: 2,
                name: 'กุมภาพันธ์'
            },
            {
                number: 3,
                name: 'มีนาคม'
            },
            {
                number: 4,
                name: 'เมษายน'
            },
            {
                number: 5,
                name: 'พฤษภาคม'
            },
            {
                number: 6,
                name: 'มิถุนายน'
            },
            {
                number: 7,
                name: 'กรกฎาคม'
            },
            {
                number: 8,
                name: 'สิงหาคม'
            },
            {
                number: 9,
                name: 'กันยายน'
            },
            {
                number: 10,
                name: 'ตุลาคม'
            },
            {
                number: 11,
                name: 'พฤศจิกายน'
            },
            {
                number: 12,
                name: 'ธันวาคม'
            }
        ];
    }
    IndexmanagerService.prototype.get_managerList = function () {
        var _getNewsPeriodUrl = cmsApi + '/get_managerList/';
        var _getNewsPeriodBody = {
            IsActive: '1',
            search: ''
        };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    IndexmanagerService.prototype.get_transactionList = function () {
        var _getNewsPeriodUrl = cmsApi + '/get_transactionList/';
        var _getNewsPeriodBody = {
            IsActive: '1',
            search: ''
        };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    IndexmanagerService.prototype.get_guidelineList = function () {
        var _getNewsPeriodUrl = cmsApi + '/get_guidelineList/';
        var _getNewsPeriodBody = {
            IsActive: '1',
            search: ''
        };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    IndexmanagerService.prototype.get_voteList = function () {
        var _getNewsPeriodUrl = cmsApi + '/get_voteList/';
        var _getNewsPeriodBody = {
            IsActive: '1',
            search: ''
        };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    IndexmanagerService.prototype.get_holdingInvestUnitList = function () {
        var _getNewsPeriodUrl = cmsApi + '/get_holdingInvestUnitList/';
        var _getNewsPeriodBody = {
            IsActive: '1',
            search: ''
        };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    IndexmanagerService.prototype.get_assignedPersonnelList = function () {
        var _getNewsPeriodUrl = cmsApi + '/get_assignedPersonnelList/';
        var _getNewsPeriodBody = {
            IsActive: '1',
            search: ''
        };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    IndexmanagerService.prototype.get_managerListById = function (managerList_id) {
        var _getNewsPeriodUrl = cmsApi + '/get_managerListById/';
        var _getNewsPeriodBody = { managerList_id: managerList_id };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    IndexmanagerService.prototype.get_transactionById = function (transaction_id) {
        var _getNewsPeriodUrl = cmsApi + '/get_transactionById/';
        var _getNewsPeriodBody = { transaction_id: transaction_id };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    IndexmanagerService.prototype.get_guidelineById = function (guideline_id) {
        var _getNewsPeriodUrl = cmsApi + '/get_guidelineById/';
        var _getNewsPeriodBody = { guideline_id: guideline_id };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    IndexmanagerService.prototype.get_voteById = function (vote_id) {
        var _getNewsPeriodUrl = cmsApi + '/get_voteById/';
        var _getNewsPeriodBody = { vote_id: vote_id };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    IndexmanagerService.prototype.get_holdingInvestUnitById = function (holdingInvestUnit_id) {
        var _getNewsPeriodUrl = cmsApi + '/get_holdingInvestUnitById/';
        var _getNewsPeriodBody = { holdingInvestUnit_id: holdingInvestUnit_id };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    IndexmanagerService.prototype.get_assignedPersonnelById = function (id) {
        var _getNewsPeriodUrl = cmsApi + '/get_AssignedPersonnelById/';
        var _getNewsPeriodBody = { id: id };
        return this.http.post(_getNewsPeriodUrl, _getNewsPeriodBody);
    };
    IndexmanagerService.prototype.changeFormatDate_dd = function (date) {
        if (date === '') {
            return null;
        }
        else {
            var d = new Date(date);
            var month_1 = d.getMonth() + 1;
            var day = d.getDate();
            var year = d.getFullYear() + 543;
            var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month_1; })[0];
            return day;
        }
    };
    IndexmanagerService.prototype.changeFormatDate_MM = function (date) {
        if (date === '') {
            return null;
        }
        else {
            var d = new Date(date);
            var month_2 = d.getMonth() + 1;
            var day = d.getDate();
            var year = d.getFullYear() + 543;
            var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month_2; })[0];
            return monthTh['name'];
        }
    };
    IndexmanagerService.prototype.changeFormatDate_yy = function (date) {
        if (date === '') {
            return null;
        }
        else {
            var d = new Date(date);
            var month_3 = d.getMonth() + 1;
            var day = d.getDate();
            var year = d.getFullYear() + 543;
            var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month_3; })[0];
            return year;
        }
    };
    IndexmanagerService.prototype.changeFormatDate = function (date) {
        if (date === '') {
            return null;
        }
        else {
            var d = new Date(date);
            var month_4 = d.getMonth() + 1;
            var day = d.getDate();
            var year = d.getFullYear() + 543;
            var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month_4; })[0];
            return day + ' ' + monthTh['name'] + ' ' + year;
        }
    };
    IndexmanagerService.prototype.date_thai = function (date) {
        var d = new Date(date);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear() + 543;
        var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month; })[0];
        return (day + ' ' + monthTh['name'] + ' ' + year);
    };
    IndexmanagerService.prototype.date_thai_dd = function (date) {
        var d = new Date(date);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear() + 543;
        var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month; })[0];
        return (day);
    };
    IndexmanagerService.prototype.date_thai_mm = function (date) {
        var d = new Date(date);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear() + 543;
        var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month; })[0];
        return (monthTh['name']);
    };
    IndexmanagerService.prototype.date_thai_yy = function (date) {
        var d = new Date(date);
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear() + 543;
        var monthTh = this.checkMonth.filter(function (m) { return m['number'] === month; })[0];
        return (year);
    };
    IndexmanagerService.ngInjectableDef = i0.defineInjectable({ factory: function IndexmanagerService_Factory() { return new IndexmanagerService(i0.inject(i1.HttpClient)); }, token: IndexmanagerService, providedIn: "root" });
    return IndexmanagerService;
}());
export { IndexmanagerService };
